import React, { useEffect, useState } from 'react';
import Uninstall from './Uninstall';
import { Switch, Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import styles from './index.module.less';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { CONTEXT } from '../../config';
import classNames from 'classnames';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { logging, logPostInfo } from '../../actions/log';
import HistoryUninstall from './HistoryUninstall';
import { getUserAppList } from '../../actions/uninstall';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function CollectUninstall() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path, url } = useRouteMatch();
  const logInfoData = useSelector(selectLogInfo);
  const location = useLocation();
  const [activeTag, setActiveTag] = useState(1);
  const tabList = [
    {
      id: 1,
      label: '本机安装应用',
      path: '/localUninstall',
      name: 'Mysofts',
    },
    {
      id: 2,
      label: '历史安装应用',
      path: '/historyUninstall',
      name: 'Mysoft_Batch',
    },
  ];

  const handleClickCollect = () => {
    // 点击我的收藏打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Collect',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };

  const handleChangeTag = info => {
    dispatch(
      logging({
        category: 'C',
        action: info.name,
        label: '',
        param2: {
          source: info.name,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    setActiveTag(info.id);
    // history.push({ pathname: `${url}${info.path}` });
    if (info.id === 2) {
      dispatch(getUserAppList());
    }
  };

  useEffect(() => {
    if (location.search) {
      setActiveTag(1);
    }
  }, [location]);

  return (
    <div className={styles.uninstall}>
      <div className={styles.header}>
        <div className={styles.tab_list}>
          {tabList.map(item => (
            <div
              key={item.id}
              className={`${styles.tab} ${
                // location.pathname === `${url}${item.path}` ? styles.tab_active : ''
                activeTag === item.id ? styles.tab_active : ''
              }`}
              onClick={() => handleChangeTag(item)}
            >
              {item.label}
            </div>
          ))}
        </div>
        <div>
          <Link
            to={{
              pathname: `${CONTEXT}/collection`,
            }}
            onClick={handleClickCollect}
          >
            <div className={styles.header_collect}>
              <i className={classNames('iconfont icon-collect', styles.collect_icon)} />
              我的收藏
            </div>
          </Link>
        </div>
      </div>
      <div className={styles.uninstall_info}>
        {activeTag === 1 && <Uninstall />}
        {activeTag === 2 && <HistoryUninstall />}
      </div>
    </div>
  );
}

export default () => (
  <KeepAlive name="uninstall">
    <CollectUninstall />
  </KeepAlive>
);
